import * as React from 'react';
import { borderRadius, colors, type } from '@workday/canvas-kit-react/tokens';
import { styled, createComponent } from '@workday/canvas-kit-react/common';
const variantStyles = {
    inverse: {
        color: colors.frenchVanilla100,
        '&:hover': {
            color: colors.frenchVanilla100,
            background: 'rgba(255, 255, 255, 0.1)',
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${colors.frenchVanilla100}`,
        },
        '&:active': {
            color: colors.blueberry600,
            background: colors.soap200,
        },
    },
};
const anchorVariants = (props) => {
    if (props.variant === 'inverse') {
        return variantStyles.inverse;
    }
    return {};
};
const Anchor = styled('a')({
    fontFamily: type.properties.fontFamilies.default,
    textDecoration: 'underline',
    color: colors.blueberry400,
    cursor: 'pointer',
    borderRadius: borderRadius.s,
    display: 'inline-block',
    padding: '0 2px',
    margin: '0 -2px',
    transition: 'color 0.15s,background-color 0.15s',
    '&:hover': {
        color: colors.blueberry500,
        background: colors.soap200,
    },
    '&:focus': {
        boxShadow: `0 0 0 2px ${colors.blueberry400}`,
        outline: 'none',
    },
    '&:active': {
        color: colors.blueberry600,
        background: colors.soap300,
    },
}, anchorVariants);
/**
 * `Hyperlink`s should be used when you want to navigate away from the current page or to an anchor
 * on the current page.
 */
export const Hyperlink = createComponent('a')({
    displayName: 'Hyperlink',
    Component: ({ children, ...elemProps }, ref, Element) => (React.createElement(Anchor, Object.assign({ ref: ref, as: Element }, elemProps), children)),
});
